import script from "./ExamList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamList.vue?vue&type=script&setup=true&lang=js"

export default script